import { InlineLink } from "../../components/ReusableStyledComponents/InlineLink";
import { UNAVAILABLE_RESOURCE_TYPE } from "../../types/unavailable_resource_type";

export const getUnavailableContentBodyCopy = (target?: UNAVAILABLE_RESOURCE_TYPE) => {
    switch (target) {
        case UNAVAILABLE_RESOURCE_TYPE.ARTICLE:
            return (
                <>
                    Oops! Looks like this content has not been made public. Please ask the owner to{" "}
                    <InlineLink href={"https://authory.com/help/en/articles/6401424-how-to-share-a-content-item"} target="_blank">
                        create a share link
                    </InlineLink>
                    .
                </>
            );
        case UNAVAILABLE_RESOURCE_TYPE.COLLECTION:
            return (
                <>
                    Oops! Looks like this collection has not been made public. Please ask the owner to{" "}
                    <InlineLink href={"https://authory.com/help/en/articles/6332390-how-to-share-a-collection"} target="_blank">
                        create a share link
                    </InlineLink>
                    .
                </>
            );
        case UNAVAILABLE_RESOURCE_TYPE.PROFILE:
            return <>Oops! Looks like this portfolio has not been made public.</>;
        default:
            return <></>;
    }
};

/**
 * Title and description shown when the account behind a resource is no longer active.
 * @param target The resource the visitor asked for
 * @returns The copy used by the matching `/*-unavailable` page
 */
export function getUnavailableResourceCopy(target?: UNAVAILABLE_RESOURCE_TYPE) {
    switch (target) {
        case UNAVAILABLE_RESOURCE_TYPE.ARTICLE:
            return { title: "Content unavailable", description: "This content item is currently not available" };
        case UNAVAILABLE_RESOURCE_TYPE.COLLECTION:
            return { title: "Collection unavailable", description: "This collection is currently not available" };
        case UNAVAILABLE_RESOURCE_TYPE.CERTIFICATE:
            return { title: "Certificate unavailable", description: "This certificate does not exist" };
        default:
            return { title: "Profile unavailable", description: "This profile is currently not available" };
    }
}
